export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              平台介绍
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">关于黑料爆料</h2>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-secondary-200/70">
            <div className="flex flex-col lg:flex-row gap-8 items-start">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-primary-500 rounded-2xl flex items-center justify-center">
                  <i className="ri-fire-line text-background-50 text-3xl md:text-4xl"></i>
                </div>
              </div>
              <div className="flex-1 space-y-4">
                <p className="text-foreground-700 leading-relaxed">
                  黑料爆料网创立于2020年，是国内领先的娱乐八卦与爆料聚合平台。我们致力于为网友提供最新、最全、最真实的娱乐圈内幕、社会热点爆料信息，打造最具活力的在线吃瓜社区。
                </p>
                <p className="text-foreground-600 leading-relaxed text-sm">
                  平台聚合全网优质爆料内容，拥有一支专业的编辑团队和遍布各行业的信源网络。我们坚持"真实第一、速度至上"的原则，对每一条爆料进行多源交叉核实，确保信息的准确性和时效性。同时，我们高度重视用户隐私保护，采用不存储浏览记录、不追踪用户行为、不泄露个人信息的"三不"原则，让每一位用户都能安心浏览。
                </p>
                <div className="flex flex-wrap gap-4 pt-2">
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-user-line text-primary-500"></i>
                    <span>百万日活用户</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-article-line text-primary-500"></i>
                    <span>累计发布爆料 12,876+</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-time-line text-primary-500"></i>
                    <span>日更 200+ 条内容</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}